var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormHelperText, Grid, Box } from "@mui/material";
import { buildFieldValidation } from "../../validators/field-components";
import { useElementConditions, useFormLogic, } from "../../context/FormLogicContext";
import Header from "../common/Header";
import MultipleTextItemInput from "./MultipleTextItemInput";
import { getInitialValueForElement, resolveTextUpdateMode, } from "../../../../utils/forms-functions";
import { getElementValueKey } from "../../../../utils/helpers";
import { useClearInvisibleValue } from "../../hooks/useClearInvisibleValue";
var MultipleTextField = function (_a) {
    var element = _a.element, errors = _a.errors;
    var _b = useFormLogic(), globalConstraints = _b.globalConstraints, globalTextUpdateMode = _b.textUpdateMode;
    var unregister = useFormContext().unregister;
    var valueKey = getElementValueKey(element);
    var error = errors[valueKey];
    var _c = useElementConditions(element), isVisible = _c.isVisible, isEnabled = _c.isEnabled, isInteractive = _c.isInteractive, fieldRequired = _c.isRequired;
    var validation = useMemo(function () {
        return buildFieldValidation(element, {
            isRequired: fieldRequired,
            readOnly: !isEnabled,
        });
    }, [element, fieldRequired, isEnabled]);
    var textUpdateMode = resolveTextUpdateMode(element, {
        textUpdateMode: globalTextUpdateMode,
    });
    useClearInvisibleValue({
        isVisible: isVisible,
        valueKeys: [valueKey],
        unregister: unregister,
    });
    var items = useMemo(function () {
        return element.items || [];
    }, [element.items]);
    var initialValue = getInitialValueForElement(element);
    var handleItemChange = function (itemName, value, currentValues, onChange) {
        var _a;
        var newValues = __assign(__assign({}, currentValues), (_a = {}, _a[itemName] = value, _a));
        onChange(newValues);
    };
    return (_jsx(_Fragment, { children: isVisible ? (_jsx(Box, __assign({ className: "component-wrapper" }, { children: _jsxs(FormControl, __assign({ fullWidth: true, error: !!error, sx: { mb: 3 } }, { children: [_jsx(Header, { element: element, error: !!error, isRequired: fieldRequired }), _jsx(Controller, { name: valueKey, defaultValue: initialValue, rules: {
                            validate: function (value) {
                                var _a;
                                var result = validation.safeParse(value);
                                if (!result.success) {
                                    return ((_a = result.error.errors[0]) === null || _a === void 0 ? void 0 : _a.message) || "Valor inválido";
                                }
                                return true;
                            },
                        }, render: function (_a) {
                            var field = _a.field;
                            var currentValues = field.value || initialValue;
                            return (_jsxs(Box, { children: [_jsx(Grid, __assign({ container: true, spacing: 2 }, { children: items.map(function (item, index) {
                                            var itemName = item.name;
                                            var itemValue = currentValues[itemName] || "";
                                            return (_jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(MultipleTextItemInput, { item: item, value: itemValue, isEnabled: isInteractive, textUpdateMode: textUpdateMode, maxLength: globalConstraints.maxTextLength, onCommit: function (name, value) {
                                                        return handleItemChange(name, value, currentValues, field.onChange);
                                                    } }) }), index));
                                        }) })), error && (_jsx(FormHelperText, __assign({ error: true, sx: { mt: 1 } }, { children: error.message })))] }));
                        } })] })) }))) : null }));
};
export default MultipleTextField;
